'use client';
import React from 'react';

import { Text } from '~components/Typography';
import annalsNavigation from '~features/annals/hooks/navigation';
import { UserInfoModal } from '~features/userInfo/ui/UserInfoModal';
import { useModal } from '~hooks/useModal';
import { useTranslations } from '~i18n/hooks';
import GearIcon from '~public/assets/icons/navigation/gear.svg';
import { DropdownElement } from '~shared/ui/atoms/Dropdown';

export const SettingsItem = () => {
	const t = useTranslations('ProfileMenu');
	const annalsNavSettingsClicked =
		annalsNavigation.useNavTopSettingsButtonClicked();

	const { open, isOpen, close } = useModal();

	return (
		<>
			<DropdownElement
				data-name="settings-item"
				icon={<GearIcon />}
				onClick={() => {
					annalsNavSettingsClicked();
					open()();
				}}
			>
				<Text size="M" align="left">
					{t('settingsTitle')}
				</Text>
			</DropdownElement>
			<UserInfoModal open={isOpen} locked={false} onClose={close} />
		</>
	);
};
